import { render, staticRenderFns } from "./information.vue?vue&type=template&id=59d56d5d&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=59d56d5d&prod&lang=scss&scoped=true"
import style1 from "./information.vue?vue&type=style&index=1&id=59d56d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d56d5d",
  null
  
)

export default component.exports